module.exports = __webpack_public_path__ + "static/media/logo.b6096a5e.png";